
export default {
  clearUserData (context) {
    context.commit('deleteToken')
    context.commit('setIsLoggedIn', false)
    context.commit('clearWishListStoreData')
    context.commit('clearCartData')
    context.commit('clearProfileDetails')
    context.commit('clearPlaylistData')
    context.commit('resetSearchType')
    context.commit('clearSearchStoreData')
    context.commit('clearCategoryStoreData')
    context.commit('clearEnrolledItemsDetails')
    context.commit('resetMostSearchWordList')
    context.commit('setSearchType', 'all')
    let i = sessionStorage.length
    while (i--) {
      let key = sessionStorage.key(i)
      sessionStorage.removeItem(key)
    }
    let j = localStorage.length
    while (j--) {
      let key = localStorage.key(j)
      localStorage.removeItem(key)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js